import SimpleModal from "../../../ui/modal/SimpleModal";
import classes from "./popup.module.scss";
interface Props {
  setEmailSentIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setPasswordResetIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const Popup = ({ setEmailSentIsOpen, setPasswordResetIsOpen }: Props) => {
  const handleRouting = () => {
    setEmailSentIsOpen(false);
    setPasswordResetIsOpen(false);
  };

  return (
    <>
      <SimpleModal setModalIsOpen={setEmailSentIsOpen}>
        <h2 className={classes.heading}>
          Nous vous avons envoyé un email pour réinitialiser votre mot de passe.
        </h2>
        <button
          type="button"
          className={classes.button}
          onClick={handleRouting}
        >
          REVENIR À L'ECRAN DE CONNEXION
        </button>
      </SimpleModal>
    </>
  );
};

export default Popup;
